import React, { useEffect, useState } from 'react';
import { Field, Formik } from 'formik';
import {
  Button,
  TextInput,
  // InputMaskField,
  TextArea,
  ComboBox,
  Icons,
} from '@components';
import { useDispatch, useSelector } from 'react-redux';
import { dadosFaleConoscoSchema } from '@schemas';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import { mdiDelete, mdiFolder } from '@mdi/js';
import {
  enviarFaleConosco,
  enviarSimulacaoEmprestimo,
} from '../../../../store/user/thunks';
import { EmprestimoService } from '../../../../common/services/emprestimo';
import { validaUploadEmprestimos } from '../utils/validaUpload';
import { ModalUpload } from './ModalUpload';

const service = new EmprestimoService();

export const Contato = ({ state = '' }) => {
  const user = useSelector((stateRedux) => stateRedux.user);
  const [assunto, setAssunto] = useState('');
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useState(() => {
    if (state?.assuntoSelecionado) {
      setAssunto(state.assuntoSelecionado);
    }
  }, []);

  const isEmprestimoOption = state?.emprestimo;

  const [assuntos, setAssuntos] = useState([]);
  const [arquivosEnvio, setArquivosEnvio] = useState([]);

  function removeArquivo(nomeArquivo) {
    setArquivosEnvio(arquivosEnvio.filter((item) => item.name !== nomeArquivo));
  }

  const ContatoInitialValues = {
    nome: user?.dadosPessoais?.nome,
    matricula: user?.data?.matricula,
    eMail: user?.dadosPessoais?.email,
    telefone: user?.dadosPessoais?.telefone?.replace(/ /g, ''),
    celular: user?.dadosPessoais?.celular?.replace(/ /g, ''),
    // eslint-disable-next-line no-nested-ternary
    assunto: isEmprestimoOption
      ? 'Empréstimo'
      : state?.assuntoSelecionado
      ? assunto
      : '',
    mensagem: '',
    anexoEmprestimo: '',
    anexoEmprestimo2: '',
    anexoEmprestimo3: '',
    anexoFaleConosco: '',
    anexoOutros: '',
  };

  useEffect(() => {
    if (!isEmprestimoOption) {
      service.obterAssuntosFaleConosco().then((res) => {
        setAssuntos(res);
      });
    }
  }, [isEmprestimoOption]);

  return (
    <div className="row justify-content-center">
      <ModalUpload modalIsOpen={modalIsOpen} setModalIsOpen={setModalIsOpen} />
      <div className="col-md-12 col-lg-8">
        <h3 className="fw-bold ts-20 mb-32">Contato</h3>
        <Formik
          validateOnMount
          initialValues={ContatoInitialValues}
          onSubmit={(values) => {
            if (isEmprestimoOption) {
              dispatch(
                enviarSimulacaoEmprestimo({
                  campos: values,
                  anexos: arquivosEnvio,
                })
              )
                .unwrap()
                .then(() => {
                  toast.success(
                    'Solicitação de empréstimo enviada com sucesso.'
                  );
                  navigate(-1);
                })
                .catch(() => {
                  toast.error('Erro ao enviar solicitação de empréstimo.');
                });
            } else {
              dispatch(enviarFaleConosco(values))
                .unwrap()
                .then(() => {
                  toast.success('Enviado com sucesso.');
                  navigate(-1);
                })
                .catch(() => {
                  toast.error('Erro no envio do fale conosco.');
                });
            }
          }}
          validationSchema={dadosFaleConoscoSchema(isEmprestimoOption)}
        >
          {({ handleSubmit, isValid }) => (
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-12 col-lg-8">
                  <Field
                    disabled
                    className="mb-1"
                    name="nome"
                    label="Nome"
                    component={TextInput}
                    type="text"
                  />
                </div>
                <div className="col-md-12 col-lg-4">
                  <Field
                    disabled
                    className="mb-1"
                    name="matricula"
                    label="Matrícula"
                    component={TextInput}
                    type="number"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 col-lg-12">
                  <Field
                    disabled
                    className="mb-1"
                    name="eMail"
                    label={
                      isEmprestimoOption
                        ? 'Confirme o e-mail para a comunicação sobre esta contratação de empréstimo'
                        : 'E-mail'
                    }
                    component={TextInput}
                    type="text"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 col-lg-6">
                  <Field
                    disabled
                    className="mb-1"
                    name="telefone"
                    // mask={
                    //   user.dadosPessoais.telefone.length === 13
                    //     ? '(11) 11111-1111'
                    //     : '(11) 1111-1111'
                    // }
                    inputMode="numeric"
                    component={TextInput}
                    label="Telefone (DDD + Número)"
                  />
                </div>
                <div className="col-md-12 col-lg-6">
                  <Field
                    disabled
                    className="mb-1"
                    name="celular"
                    // mask={
                    //   user.dadosPessoais.celular.length === 13
                    //     ? '(11) 11111-1111'
                    //     : '(11) 1111-1111'
                    // }
                    inputMode="numeric"
                    component={TextInput}
                    label="Celular (DDD + Número)"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 col-lg-12">
                  <Field
                    disabled={state}
                    className="mb-1"
                    name="assunto"
                    label="Assunto de interesse"
                    component={state ? TextInput : ComboBox}
                    type="text"
                    options={assuntos.map((x) => {
                      return { value: x, label: x };
                    })}
                  />
                </div>
              </div>
              {!isEmprestimoOption && (
                <div className="row-TextArea">
                  <div className="col-md-12 col-lg-12">
                    <Field
                      className="mb-1 "
                      name="mensagem"
                      label="Mensagem"
                      component={TextArea}
                      type="text"
                    />
                  </div>
                </div>
              )}
              <div className="row">
                <div className="col-md-12 col-lg-12">
                  <Field
                    className="mb-1"
                    name={
                      isEmprestimoOption
                        ? 'anexoEmprestimo'
                        : 'anexoFaleConosco'
                    }
                    type="file"
                    label={
                      isEmprestimoOption
                        ? 'Adicionar arquivo (obrigatório)'
                        : 'Adicionar arquivo'
                    }
                    accept="image/*,.pdf"
                  >
                    {({ form }) => {
                      return (
                        <TextInput
                          className="mb-1"
                          name={
                            isEmprestimoOption
                              ? 'anexoEmprestimo'
                              : 'anexoFaleConosco'
                          }
                          type="file"
                          multiple
                          label={
                            isEmprestimoOption
                              ? 'Adicionar contrato completo ou páginas do contrato'
                              : 'Adicionar arquivo'
                          }
                          accept="image/*,.pdf"
                          onChange={(e) => {
                            return validaUploadEmprestimos({
                              e,
                              form,
                              setModalIsOpen,
                              campo: isEmprestimoOption
                                ? 'anexoEmprestimo'
                                : 'anexoFaleConosco',
                              setArquivosEnvio,
                              arquivosEnvio,
                            });
                          }}
                        />
                      );
                    }}
                  </Field>
                </div>
              </div>
              {arquivosEnvio.length > 0 && (
                <div>
                  <h4>Arquivos Selecionados</h4>
                  <hr />
                  {arquivosEnvio.map((item) => {
                    return (
                      <List key={item.name}>
                        <ListItem
                          secondaryAction={
                            <IconButton
                              edge="end"
                              aria-label="delete"
                              onClick={() => removeArquivo(item.name)}
                            >
                              <Icons
                                path={mdiDelete}
                                color="var(--primary-color)"
                              />
                            </IconButton>
                          }
                        >
                          <ListItemAvatar>
                            <Avatar>
                              <Icons
                                path={mdiFolder}
                                color="var(--primary-color)"
                              />
                            </Avatar>
                          </ListItemAvatar>
                          {item.name}
                        </ListItem>
                      </List>
                    );
                  })}
                </div>
              )}
              <div className="row">
                <div className="col-12 col-md-6 col-xl-4 ms-0 ms-md-auto">
                  <div className="d-block d-md-flex align-items-center">
                    <Button
                      disabled={!isValid}
                      className="ms-0 ms-md-3"
                      onClick={handleSubmit}
                    >
                      Enviar
                    </Button>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};
